export default "__VITE_ASSET__DEK6rbyT__"